import { useContext } from 'react';
import { UserContext } from '../../context';
import { useMeNewsletterConsentsQuery } from '../../services';

export const useIsNewslettersAllowed = () => {
  const { isAnonymous } = useContext(UserContext).userProfile;

  const { data } = useMeNewsletterConsentsQuery(undefined, { skip: isAnonymous });

  return !isAnonymous && Boolean(data?.isOn) && Boolean(data?.lists.length);
};
